"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_upload_style_1 = __importDefault(require("./uicon.upload.style"));
class UiconUpload extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: [jsx_runtime_1.jsx("path", { d: "M24.462 20.0596V23.3596C24.462 23.7266 23.862 24.1376 23.062 24.1376H8.70001C7.90001 24.1376 7.3 23.7266 7.3 23.3596V20.0596H6V23.3596C6 24.5246 7.18601 25.4376 8.70001 25.4376H23.06C24.575 25.4376 25.76 24.5246 25.76 23.3596V20.0596H24.462Z", className: classes.fill }, void 0),
                    jsx_runtime_1.jsx("path", { d: "M15.23 7.66648V20.3105H16.53V7.66648L20.981 12.1165L21.9 11.1975L17.252 6.55048C16.8826 6.19718 16.3911 6 15.88 6C15.3688 6 14.8774 6.19718 14.508 6.55048L9.85999 11.1975L10.779 12.1165L15.23 7.66648Z", className: classes.fill }, void 0)] }), void 0));
        };
    }
}
UiconUpload.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconUpload.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_upload_style_1.default)(UiconUpload);
//# sourceMappingURL=uicon.upload.js.map